/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.33/esri/copyright.txt for details.
*/
class e{constructor(e){this.getUnmaskedRenderer=e}}function n(n){const r=n.getExtension("WEBGL_debug_renderer_info");return r?new e((()=>n.getParameter(r.UNMASKED_RENDERER_WEBGL))):null}export{e as RendererInfo,n as loadRendererInfo};
